import React from 'react';
import { Modal, Descriptions } from 'antd';
import './index.less';

const { Item } = Descriptions;

const noDrawling = `${process.env.TARGET}static/imgs/no-drawing.jpg`;

export default React.memo(
  ({ modalVisible, material, standard, spec, projectNo, name, handleCancel, imgs }) => {
    const [currentImg, setCurrentImg] = React.useState('');

    React.useEffect(() => {
      if (imgs && imgs[0]) {
        setCurrentImg(imgs[0]);
      } else {
        setCurrentImg(null);
      }
    }, [imgs]);
    return (
      <Modal
        visible={modalVisible}
        footer={null}
        destroyOnClose={true}
        wrapClassName="drawing-modal table-list-imgs-modal"
        onCancel={handleCancel}
      >
        <div className="img-preview">
          <img
            src={currentImg ? `${process.env.ASSETS}/${currentImg}` : noDrawling}
            alt="加载中..."
            style={{ width: 400, height: 400 }}
            // onError={handleError}
          />
        </div>
        <div className="imgs-list">
          {imgs.map((item) => (
            <img
              key={item}
              className={`${currentImg === item ? 'selected-img' : ''}`}
              src={item ? `${process.env.ASSETS}/${item}` : noDrawling}
              alt="加载中..."
              style={{ width: 85, height: 85 }}
              onClick={() => setCurrentImg(item)}
              // onError={handleError}
            />
          ))}
        </div>
        <div className="text-red">*图片、图纸、印记等仅供参考，请以实物为准</div>
        <Descriptions bordered={true}>
          <Item label="材质">{material}</Item>
          <Item label="标准">{standard}</Item>
          <Item label="规格">{spec}</Item>
          <Item label="项目号">{projectNo}</Item>
          <Item label="品名">{name}</Item>
        </Descriptions>
      </Modal>
    );
  },
);
